import { css } from 'styled-components';

// size settings
export const sizeSmall = css`
    border: none;
    font-size: 13px;
    padding: 2px 12px;
`;

export const sizeRegular = css`
    font-size: 14px;
    padding: 4px 16px;
`;

export const sizeLarge = css`
    border-width: 4px;
    font-size: 16px;
    padding: 4px 20px;
`;
